module.exports = __webpack_public_path__ + "static/media/c18.e1e8a891.png";